import { render, staticRenderFns } from "./ContentImg.vue?vue&type=template&id=5f3883a2&scoped=true&"
import script from "./ContentImg.vue?vue&type=script&lang=js&"
export * from "./ContentImg.vue?vue&type=script&lang=js&"
import style0 from "./ContentImg.vue?vue&type=style&index=0&id=5f3883a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3883a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3883a2')) {
      api.createRecord('5f3883a2', component.options)
    } else {
      api.reload('5f3883a2', component.options)
    }
    module.hot.accept("./ContentImg.vue?vue&type=template&id=5f3883a2&scoped=true&", function () {
      api.rerender('5f3883a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/msg/ContentImg.vue"
export default component.exports